import { inject, Injectable } from '@angular/core';
import { Actions } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { ToastrService } from 'src/app/shared/services/toastr/toastr-service';
import { LangService } from 'src/app/shared/services/lang/lang.service';
import { ApiService } from 'src/app/shared/services/api/api.service';
import {
  createCryptotokenKeyDataEffects,
  createCryptotokenKeyDeleteEffects,
  CryptotokenKeyDataActions,
} from './cryptotoken-keys.feature';
import { extractErrorMessage } from 'src/app/shared/util/extract-error-message';

@Injectable()
export class CryptotokenKeyDataEffects {
  private action$ = inject(Actions);
  private store = inject(Store);
  private apiService = inject(ApiService);
  private toastrService = inject(ToastrService);
  private langService = inject(LangService);
  private labels = this.langService.lang.features.cryptotokenKeys;

  private effects = createCryptotokenKeyDataEffects(this.action$, this.store, {
    load: ({ tokenName }) => this.apiService.getCryptotokenKeys(tokenName),
    notifyError: ({ tokenName }) =>
      this.toastrService.error(this.labels.toasts.fetchingError(tokenName)),
  });

  fail$ = this.effects.fail$;
  load$ = this.effects.load$;
  ensure$ = this.effects.ensure$;

  private deleteEffects = createCryptotokenKeyDeleteEffects(this.action$, {
    deleteItem: ctKey =>
      this.apiService.deleteCryptotokenKey(
        ctKey.tokenName,
        ctKey.details.alias,
      ),
    notifyError: (ctKey, error) =>
      this.toastrService.error(
        extractErrorMessage(error) ||
          this.labels.toasts.defaultDeletionError(ctKey),
      ),
    notifySuccess: ctKey =>
      this.toastrService.success(this.labels.toasts.deletionSuccess(ctKey)),
    onSuccess: ctKey =>
      this.store.dispatch(
        CryptotokenKeyDataActions.transform({
          transformation: keys =>
            keys.filter(key => key.details.alias !== ctKey.details.alias),
        }),
      ),
  });

  delete$ = this.deleteEffects.delete$;
  deleteFail$ = this.deleteEffects.deleteFail$;
  deleteSuccess$ = this.deleteEffects.deleteSuccess$;
}
